import { useEffect, useState } from "react";

/**
 * Retarde la mise à jour d'une valeur
 *
 * @template T
 * @param {T} value - Valeur à debouncer
 * @param {number} [delay=150] - Délai en millisecondes (150ms par défaut)
 * @returns {T} Valeur après temporisation
 */
export const useDebounce = (value, delay = 150) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => clearTimeout(timer);
	}, [value, delay]);

	return debouncedValue;
};
